import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init() {

    }

    toggle() {
        this.call('open', null, 'Share')
    }
}
